import * as S from "./LoginForm.style";
import { Buttons } from "@/components/atoms/Buttons";

interface LoginFormProps {
  children: React.ReactElement;
  onSubmit?: any;
  typeSelect?: React.ReactElement;
}

export const LoginForm = ({
  children,
  onSubmit,
  typeSelect,
}: LoginFormProps) => {
  return (
    <S.LoginForm onSubmit={onSubmit}>
      {typeSelect}
      <S.LoginInputRow>{children}</S.LoginInputRow>
      <Buttons
        type="submit"
        size="lg"
        color="primary100"
        layout="solid"
        label="로그인"
      />
      <S.LoginFormDivider>
        <span>또는</span>
      </S.LoginFormDivider>
    </S.LoginForm>
  );
};
